export const DOCUMENT_CATEGORY_OPTIONS = [
  { value: "report", label: "Report" },
  { value: "receipt", label: "Receipt" },
  { value: "certificate", label: "Certificate" },
  { value: "photo", label: "Photo" },
  { value: "other", label: "Other" },
];

export const resolveDocumentCategory = (doc) => {
  const stored = String(doc?.document_category || "").toLowerCase().trim();
  if (stored && stored !== "other") return stored;

  const title = String(doc?.title || "").toLowerCase();
  if (/(receipt|payment)/i.test(title)) return "receipt";
  if (/(certificate|cert)/i.test(title)) return "certificate";
  if (/(report|admission|form)/i.test(title)) return "report";
  if (doc?.resource_type === "image") return "photo";
  return "other";
};
